import useColors from "../customHooks/useColors.js";
import { Container, Row, Col } from "reactstrap";
import useBootstrap from "../customHooks/useBootstrap.js";
import BaseParagraph from "../baseComponents/baseParagraph.js";
import { useSelector } from "react-redux";
import BaseHyprelink from "../baseComponents/baseHyperlink.js";
import WithContactInfo from "../HOC/WithContactInfo.js";

const Footer = ({ openContactInfo = () => {} }) => {
  const [currentColors] = useColors();

  const { trashold4, classes } = useBootstrap();

  const systemState = useSelector((state) => state.systemState);

  const rulesLink = systemState.settings.rules_link;
  const dataProcessingLink = systemState.settings.data_processing_link;

  const styles = {
    footer: {
      backgroundColor: currentColors.primary,
      paddingTop: "7px",
      paddingBottom: "7px",
      // position: "fixed",
      // bottom: 0,
      // left: 0
    },
    footerContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    footerText: {
      color: currentColors.secondary,
      textAlign: "center",
    },
  };

  return (
    <Container style={styles.footer} fluid>
      <Row>
        <Col style={{ ...styles.footerContainer }} {...trashold4}>
          <BaseParagraph
            onClick = {openContactInfo}
            style={{...styles.footerText, cursor: "pointer"}}
            className={classes.onOrAboveTrashold.marginTop(true)}
          >
            contact
          </BaseParagraph>
        </Col>
        <Col style={{ ...styles.footerContainer }} {...trashold4}>
          <BaseHyprelink
            className={classes.onOrAboveTrashold.marginTop(true)}
            href={rulesLink}
            style={styles.footerText}
          >
            rules
          </BaseHyprelink>
          <BaseHyprelink
            className={classes.onOrAboveTrashold.marginTop(true)}
            href={dataProcessingLink}
            style={styles.footerText}
          >
            dataProcessing2
          </BaseHyprelink>
        </Col>
        <Col style={{ ...styles.footerContainer }} {...trashold4}>
          <BaseParagraph
            className={classes.onOrAboveTrashold.marginTop(true)}
            translate={false}
            style={styles.footerText}
          >
            {systemState.settings.copyright_text}
          </BaseParagraph>
        </Col>
      </Row>
    </Container>
  );
};

export default WithContactInfo(Footer);
